<template>
  <div>
    <com-table :columns="columns" :api="api" ref="tableRef" :default-params="defaultParams">
      <template #createTime="row">
        <div v-if="row.data.createTime">
          {{ row.data.createTime | formatDate }}
        </div>
      </template>
      <template #effectiveTime="row">
        <div v-if="row.data.effectiveTime">
          {{ row.data.effectiveTime | formatDate }}
        </div>
      </template>
      <template #expireTime="row">
        <div v-if="row.data.expireTime">
          {{ row.data.expireTime | formatDate }}
        </div>
      </template>
      <template #operationTime="row"> {{ row.data.operationTime }}天 </template>
      <template #putAway="row">
        <el-switch
          @change="handleEditStatus(row.data)"
          v-model="row.data.status"
          active-value="1"
          inactive-value="0"
        ></el-switch>
      </template>
      <template #deviceCount="row">
        {{ row.data.availableDevCount }} / {{ row.data.deviceCount }}
      </template>
      <template #operation="row">
        <el-button type="primary " @click="handleDetail(row.data)" class="mb-5rpx" size="mini"
          >查看</el-button
        >
        <el-button type="primary " @click="handleEdit(row.data)" class="mb-5rpx" size="mini"
          >编辑</el-button
        >
        <el-button type="danger" @click="handleDel(row.data)" class="mb-5rpx" size="mini"
          >删除</el-button
        >
      </template>
    </com-table>
  </div>
</template>

<script>
import { siteListApi, delSiteApi, updateStatus } from '@/api/site'

export default {
  props: {
    model: {
      type: String,
      default: ''
    },
    defaultParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      api: siteListApi,
      columns: [
        {
          label: '编号',
          prop: 'number',
          width: '150'
        },
        {
          label: '网点名称',
          prop: 'name',
          minWidth: '150'
        },
        {
          label: '地址',
          prop: 'address',
          minWidth: '200'
        },
        {
          label: '区域',
          prop: 'areaName',
          auto: true
        },
        {
          label: '网点有效年份',
          prop: 'storeAge'
        },
        {
          label: '已运营时间',
          prop: 'operationTime',
          type: 'slot',
          slotName: 'operationTime'
        },
        {
          label: '设备数',
          prop: 'deviceCount',
          type: 'slot',
          slotName: 'deviceCount'
        },
        {
          label: '订单笔数',
          prop: 'orderCount'
        },
        {
          label: '订单金额',
          prop: 'orderAmount'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          minWidth: '120',
          type: 'slot',
          slotName: 'createTime'
        },
        {
          label: '创建人',
          prop: 'createBy',
          minWidth: '150'
        },
        {
          label: '生效时间',
          prop: 'effectiveTime',
          minWidth: '120',
          type: 'slot',
          slotName: 'effectiveTime'
        },
        {
          label: '到期时间',
          prop: 'expireTime',
          minWidth: '120',
          type: 'slot',
          slotName: 'expireTime'
        },
        {
          label: '上下架',
          prop: 'putAway',
          minWidth: '120',
          type: 'slot',
          slotName: 'putAway'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          minWidth: '180'
        }
      ]
    }
  },
  watch: {
    model: {
      handler(val) {
        if (val) {
          if (val === 'shop') {
            this.columns.splice(-2, 2)
          }
        }
      },
      immediate: true,
      deep: true
    },
    defaultParams: {
      handler(val) {
        if (val && val.partnerCode) {
          this.columns.splice(4, 0, {
            label: '分成',
            prop: 'partnerDivide'
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init() {
      if (this.defaultParams && this.defaultParams.areaPartnerCode) {
        this.columns.splice(4, 1)
      }
      // if (this.defaultParams && this.defaultParams.partnerCode) {
      //   this.columns.splice(4, 0, {
      //     label: '分成',
      //     prop: 'partnerDivide'
      //   })
      // }
      this.$refs.tableRef.init()
    },
    handleDetail(row) {
      this.$router.push({ name: 'site-edit', params: { type: 'watch', row } })
    },
    handleEdit(row) {
      this.$router.push({ name: 'site-edit', params: { type: 'edit', row } })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该网点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          delSiteApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    search(val) {
      this.$refs.tableRef.search(val)
    },
    async handleEditStatus(row) {
      console.log('row :>> ', row)
      const params = {
        code: row.code,
        status: row.status
      }
      const res = await updateStatus(params)
      if (res.status === 200) {
        this.$message.success('操作成功')
        this.$refs.tableRef.getList()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
